<p-breadcrumb
  [model]="[
    { label: 'Parâmetros', routerLink: ['/parameters'] },
    {
      label: 'Editar Parâmetro',
      routerLink: ['/parameters/update', parameterId()]
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        <h5 class="font-bold">Editar Parâmetro</h5>
        <p>Atualize o valor do parâmetro</p>
      </div>

      <div class="flex justify-end gap-2">
        <p-button
          label="Cancelar"
          routerLink="/parameters"
          severity="secondary"
          rounded
          class="btn-secondary-outline"
        >
        </p-button>
        <p-button
          type="submit"
          label="Salvar"
          [disabled]="formGroup.invalid"
          rounded
        ></p-button>
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5 w-full">
    <h5 class="font-bold">Informações do parâmetro</h5>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="key">Chave</label>
        <input pInputText type="text" formControlName="key" class="w-full" />
        <app-form-error [control]="formGroup.get('key')" />
        <app-form-server-error [control]="formGroup.get('key')" />
      </div>

      <div class="w-full">
        <label for="value">Valor *</label>
        <input
          pInputText
          type="text"
          formControlName="value"
          class="w-full"
          placeholder="Informe o valor"
        />
        <app-form-error [control]="formGroup.get('value')" />
        <app-form-server-error [control]="formGroup.get('value')" />
      </div>
    </div>
  </div>

  @if(loading()){
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading" />
  </div>
  }
</form>

<p-toast />
